import { useEffect } from "react";
import { Href } from "../../Constant";
import { isMenuUrlActive } from "../../Helper/ActioveNavUrl";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import locationMenuCfg from "../../Config/locationMenu.json";
import { isLocationSidebarContext } from "../../helpers/locationContext";

const LOCATION_MENU_SECTION_TITLES = locationMenuCfg.sections.map((s) => s.title);

const isLocationMenuRootSection = (item) =>
  item && LOCATION_MENU_SECTION_TITLES.includes(item.title);

const SidebarSubMenu = ({ menu, className, setIsOpen, isOpen, level }) => {
  const { pathname, search } = useLocation();
  const { t } = useTranslation();
  function shouldSetActive({ item }) {
    var returnValue = false;
    if (isLocationMenuRootSection(item) && isLocationSidebarContext(pathname, search)) {
      return true;
    }
    if (item?.url && isMenuUrlActive(item.url, pathname)) {
      returnValue = true;
    }
    if (!returnValue && item?.menu) {
      item?.menu.every((subItem) => {
        returnValue = shouldSetActive({ item: subItem });
        return !returnValue;
      });
    }
    return returnValue;
  }

  useEffect(() => {
    menu.forEach((item) => {
      const gotValue = shouldSetActive({ item });
      if (gotValue) {
        setIsOpen((prev) => {
          const next = [...prev];
          next[level] = item.title;
          return next;
        });
      }
    });
  }, [pathname, search, menu, level, setIsOpen]);

  return (
    <ul className={`${className ? className : ""}`}>
      {menu.map((item, i) => {
        const linkActive = item.menu
          ? item.menu
              .map((innerItem) => isMenuUrlActive(innerItem.url, pathname))
              .includes(true)
          : isMenuUrlActive(item.url, pathname);
        const locationSectionActive =
          isLocationMenuRootSection(item) &&
          isLocationSidebarContext(pathname, search);
        const itemActive = linkActive || locationSectionActive;
        const toggleSubmenu = () => {
          setIsOpen((prev) => {
            const next = [...prev];
            next[level] = prev[level] === item.title ? false : item.title;
            return next;
          });
        };
        const parentOnlySubmenu = Boolean(item.menu && !item.url);
        return (
        <li
          key={i}
          className={`${className ? "" : "sidebar-title"}  ${
            itemActive || isOpen[level] === item.title ? "active" : ""
          }`}
        >
          {parentOnlySubmenu ? (
            <button
              type="button"
              className={`${className ? "" : "sidebar-link sidebar-title"}  ${
                itemActive || isOpen[level] === item.title ? "active": ""}`}
              onClick={toggleSubmenu}
            >
              {item.icon ? item.icon : ""}
              <span className={`${item.class ? item.class : ""}`}>
                {t(item.title)}
              </span>
              <div className="according-menu"><i className="fa fa-angle-right"></i></div>
            </button>
          ) : (
          <Link
            className={`${className ? "" : "sidebar-link sidebar-title"}  ${
              itemActive || isOpen[level] === item.title ? "active": ""}`}
            to={item.url ? item.url : Href}
            onClick={() => {
              if (item.menu) {
                toggleSubmenu();
              }
            }}
          >
              {item.icon ? item.icon : ""}
              <span className={`${item.class ? item.class : ""}`}>
                {t(item.title)}
              </span>
            {/* Раздел открывается вместе с ролью. Метка честнее, чем
                спрятать пункт: человек видит, что в кабинете есть ещё, и
                понимает, отчего оно закрыто. */}
            {item.lock && <span className="fw-nav-lock">{item.lock}</span>}
            {item.menu && (<div className="according-menu"><i className="fa fa-angle-right"></i></div>)}
          </Link>
          )}
          {item.menu && (
            <SidebarSubMenu menu={item.menu} isOpen={isOpen} setIsOpen={setIsOpen} level={level + 1} className="sidebar-submenu "
            />
          )}
        </li>
        );
      })}
    </ul>
  );
};

export default SidebarSubMenu;